'use strict';

angular.module('licensure.services')
    .factory('Correspondences', ['$http', '$q', '$rootScope', function ($http, $q, $rootScope) {
        var prepareArrayField = function (obj) {
            var result = '';
            if (obj != null) {
                for (var i = 0, l = obj.length; i < l; i++) {
                    if (i > 0) {
                        result = result + ',' + obj[i].id;
                    } else {
                        result = obj[i].id;
                    }
                }
            }
            return result;
        };

        return {
            getByID: function (id) {
                var d = $q.defer();

                $http.get(apiLocation + '/api/Correspondences/' + id, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (correspondence, args) {
                var d = $q.defer();

                var correspondenceData = angular.extend({}, {
                    mergeEntityID: correspondence.merge_entity_id,
                    message: correspondence.message,
                    subject: correspondence.subject,
                    from_address: prepareArrayField(correspondence.from_address),
                    to_address: prepareArrayField(correspondence.to_address),
                    cc_address: prepareArrayField(correspondence.cc_address),
                    bcc_address: prepareArrayField(correspondence.bcc_address),
                    replyTo_address: prepareArrayField(correspondence.replyto_address),
                    userDocumentIDs: prepareArrayField(correspondence.include_documents),
                    mergeTemplateID: correspondence.merge_template_id,
                    save_correspondence_object: true,
                    sendTemplate: 0,
                    saveDataObjects: true,
                    enterpriseID: $rootScope.enterpriseID,
                    initiatedByID: $rootScope.userID,
                    respondEmail: false
                }, args);

                $http({
                    method: 'POST',
                    url: $rootScope.internalURL + 'controller.cfm?method=CorrespondenceService.sendCorrespondenceAngularJS&returnFormat=json',
                    data: correspondenceData
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            downloadZIP: function (correspondenceIds) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Core/Correspondence/Zip', { correspondenceIds: correspondenceIds }).
                    then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;